import api from './api'
import { ApiResponse } from '../types'

export interface NotificationEmail {
  id: string
  email: string
  name: string | null
  isActive: boolean
  createdAt: string
  updatedAt: string
}

export interface CreateNotificationEmailData {
  email: string
  name?: string
  isActive?: boolean
}

export interface UpdateNotificationEmailData {
  email?: string
  name?: string | null
  isActive?: boolean
}

export const notificationEmailService = {
  async getAll(): Promise<NotificationEmail[]> {
    const response = await api.get<ApiResponse<NotificationEmail[]>>(
      '/configuration/emails'
    )
    return response.data.data
  },

  async getById(id: string): Promise<NotificationEmail> {
    const response = await api.get<ApiResponse<NotificationEmail>>(
      `/configuration/emails/${id}`
    )
    return response.data.data
  },

  async create(data: CreateNotificationEmailData): Promise<NotificationEmail> {
    const response = await api.post<ApiResponse<NotificationEmail>>(
      '/configuration/emails',
      data
    )
    return response.data.data
  },

  async update(id: string, data: UpdateNotificationEmailData): Promise<NotificationEmail> {
    const response = await api.put<ApiResponse<NotificationEmail>>(
      `/configuration/emails/${id}`,
      data
    )
    return response.data.data
  },

  async delete(id: string): Promise<void> {
    await api.delete(`/configuration/emails/${id}`)
  },

  async toggleActive(id: string): Promise<NotificationEmail> {
    const response = await api.patch<ApiResponse<NotificationEmail>>(
      `/configuration/emails/${id}/toggle`
    )
    return response.data.data
  },
}
